import { useEffect, useRef, useState } from "react";
import { Menu, X, Home } from "lucide-react";
import { SECTIONS } from "./PublicHome";

export default function PublicMenu({ sec, go }) {
  const [open, setOpen] = useState(false);
  const ref = useRef(null);
  useEffect(() => {
    if (!open) return;
    const close = (e) => ref.current && !ref.current.contains(e.target) && setOpen(false);
    document.addEventListener("pointerdown", close);
    return () => document.removeEventListener("pointerdown", close);
  }, [open]);
  const pick = (id) => {
    setOpen(false);
    go(id);
  };
  const items = [{ id: "home", label: "Copertă", hint: "Pagina de start", Icon: Home }, ...SECTIONS];
  return (
    <div className="pub-menu-wrap" ref={ref}>
      <button type="button" className={`pub-menu-btn ${open ? "is-open" : ""}`} onClick={() => setOpen((o) => !o)} aria-expanded={open} data-testid="public-menu-btn">
        {open ? <X size={16} /> : <Menu size={16} />} MENIU
      </button>
      {open && (
        <nav className="pub-dropdown" data-testid="public-menu-dropdown">
          {items.map(({ id, label, hint, Icon }, i) => (
            <button key={id} type="button" className={sec === id ? "is-active" : ""} onClick={() => pick(id)} style={{ animationDelay: `${i * 40}ms` }} data-testid={`menu-item-${id}`}>
              <span className="pub-tile-icon"><Icon size={16} /></span>
              <span className="pub-tile-text"><b>{label}</b><small>{hint}</small></span>
            </button>
          ))}
        </nav>
      )}
    </div>
  );
}
